import { useAppSelector } from '../../app/hooks'
import { useCaseDossier } from '../../selectors/dossierSelectors'
import { CaseDossier, DossierTypeEnum } from '../../shared/types'

const useChapter = () => {
  // ver 1
  const userDossier = useCaseDossier()

  // ver 2
  // const { data } = useAppSelector((state) => state.dossier)
  // const stateDossier = data as CaseDossier

  // const stateChapter =
  //   stateDossier?.type === DossierTypeEnum.Case && stateDossier.activeChapterId

  return {
    chapterId: userDossier?.activeChapterId,
    caseComplete: userDossier?.caseComplete,
  }
}

export default useChapter
